<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
</style>
<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <h4 class="mb-5">Supplier Invoice</h4>
    </span>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Supplier"
          name="Supplier"
          v-model="vendor"
          readonly
        />
      </div>
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="PO Code"
          name="PO Code"
          v-model="poCode"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Warehouse"
          name="Warehouse"
          v-model="warehouseName"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Number"
          name="Invoice Number"
          v-model="table.inv_code"
          placeholder="Invoice Number"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Date"
          name="Invoice Date"
          v-model="table.inv_date"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Due Date"
          name="Due Date"
          v-model="table.due_date"
          readonly
        />
      </div>
    </div>
    <div v-if="createdDate != 'January 1, 0001'" class="vx-col w-full mb-2">
      <vs-input
        class="w-full input-readonly"
        label="Created Date"
        name="Created Date"
        v-model="createdDate"
        readonly
      />
    </div>
    <div class="vx-row mb-2" style="z-index: 99999 !important">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Payment Term"
          name="Payment Term"
          v-model="table.payment_term_name"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2" style="z-index: 99999 !important">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Bank Name"
          name="Bank Name"
          v-model="table.bank_name"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Tax Invoice Number"
          name="Tax Invoice Number"
          v-model="tr_number"
          placeholder="Tax Invoice Number"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Tax Invoice Date"
          name="Tax Invoice Date"
          v-model="tr_date"
          placeholder="Tax Invoice Date"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2 ml-1">
      <h5>Line Item</h5>
    </div>
    <vs-table stripe border description :sst="true" :data="table.data">
      <template slot="thead">
        <vs-th>Item</vs-th>
        <vs-th>Qty Inv</vs-th>
        <vs-th>Total Price</vs-th>
        <vs-th>Discount</vs-th>
        <vs-th>Net</vs-th>
        <vs-th>Tax</vs-th>
        <vs-th>Withholding tax</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].item_name }}</span>
            </div>
            <div class="vx-row ml-0">
              <span class="w-5/5"
                >Received :
                {{
                  data[indextr].qty_received
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                {{ data[indextr].item_unit }}</span
              >
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].quantity }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].net }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].discount }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].subtotal }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].tax }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].wh_tax }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="vx-row mb-2 mt-5 ml-1">
      <h5>Charges</h5>
    </div>
    <vs-table stripe border description :sst="true" :data="table.data_charges">
      <template slot="thead">
        <vs-th>Charge Name</vs-th>
        <vs-th>Value</vs-th>
        <vs-th>Tax</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{
                data[indextr].charge_name.replace(/-/g, " ")
              }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].value }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].tax }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%; margin-left: 2%"><b>Notes</b></vs-divider>
    <template v-for="note in notes">
      <b v-bind:key="note"
        >{{ note }}
        <br />
      </b>
    </template>
    <br />
    <vs-textarea v-model="new_notes" />
    <vs-divider style="width: 100%; margin-left: 2%"><b>Comment</b></vs-divider>
    <vs-textarea v-model="comment" />
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Description</b></vs-divider
    >
    <vs-textarea v-model="description" />
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Proposal Payment History </b></vs-divider
    >
    <vs-table
      stripe
      border
      description
      :sst="true"
      :data="table.data_payment_proposal"
    >
      <template slot="thead">
        <vs-th>Code</vs-th>
        <vs-th>Plan Date Payment</vs-th>
        <vs-th>Paid</vs-th>
        <vs-th>Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            {{ tr.Code }}
          </vs-td>
          <vs-td>
            {{ dateFormat(tr.PurposePaymentDate) }}
          </vs-td>
          <vs-td>
            {{ tr.PaidValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </vs-td>
          <vs-td>
            <template v-if="tr.Status == 0"> Waiting </template>
            <template v-else-if="tr.Status == 1">
              Approved, Waiting Execute
            </template>
            <template v-else-if="tr.Status == 2"> Rejected </template>
            <template v-else-if="tr.Status == 3"> Done </template>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>List Payment</b></vs-divider
    >
    <vs-table
      stripe
      border
      description
      class="w-full"
      :sst="true"
      :data="table.data_payment"
    >
      <template slot="thead">
        <vs-td style="text-align: center"><b>Payment Account</b></vs-td>
        <vs-td style="text-align: center"><b>Payment Voucher</b></vs-td>
        <vs-td style="text-align: right"><b>Paid</b></vs-td>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td style="text-align: center" :data="data[indextr].BankName">
            {{
              data[indextr].BankID == 0
                ? data[indextr].Type == 2
                  ? "DN"
                  : "-"
                : data[indextr].BankName + " " + data[indextr].AccountNumber
            }}
          </vs-td>
          <vs-td style="text-align: center">
            {{ data[indextr].ReferenceCode }}
          </vs-td>
          <vs-td style="text-align: right">
            {{
               Math.round(data[indextr].PaidInvoiceValue).toString().replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )
            }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="flex flex-row gap-3 justify-start w-full mt-3">
      <vs-checkbox :disabled="true" v-model="vat_expired"
        >Vat Expired</vs-checkbox
      >
      <vs-checkbox :disabled="true" v-model="is_skb">SKB</vs-checkbox>
    </div>

    <div class="vx-row w-5/5 mb-3 mt-6">
      <vs-input
        class="w-1/6 input-readonly"
        label="Item Value"
        name="Item Value"
        v-model="table.item_value"
        readonly
      />

      <vs-input
        class="w-1/6 input-readonly pl-1 pr-1"
        label="Charges Value"
        name="Charges Value"
        v-model="table.charges_value"
        readonly
      />

      <vs-input
        class="w-1/6 input-readonly pr-1"
        label="Tax Value"
        name="Tax Value"
        v-model="table.tax_value"
        readonly
      />

      <vs-input
        class="w-1/6 input-readonly pr-1"
        label="Discount Value"
        name="Discount Value"
        v-model="table.discount_value"
        readonly
      />

      <vs-input
        class="w-1/6 input-readonly pr-1"
        label="Total Withholding Tax"
        name="Total Withholding Tax"
        v-model="table.total_whtax"
        readonly
      />

      <vs-input
        class="w-1/6 input-readonly"
        label="Total Invoice Value"
        name="Total Invoice Value"
        v-model="table.total_inv_value"
        readonly
      />
    </div>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Proposal Payment History </b></vs-divider
    >
    <vs-table
      stripe
      border
      description
      :sst="true"
      :data="table.data_payment_proposal"
    >
      <template slot="thead">
        <vs-th>Code</vs-th>
        <vs-th>Plan Date Payment</vs-th>
        <vs-th>Paid</vs-th>
        <vs-th>Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            {{ tr.Code }}
          </vs-td>
          <vs-td>
            {{ dateFormat(tr.PurposePaymentDate) }}
          </vs-td>
          <vs-td>
            {{ tr.PaidValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </vs-td>
          <vs-td>
            <template v-if="tr.Status == 0"> Waiting </template>
            <template v-else-if="tr.Status == 1">
              Approved, Waiting Execute
            </template>
            <template v-else-if="tr.Status == 2"> Rejected </template>
            <template v-else-if="tr.Status == 3"> Done </template>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>List Attachment</b></vs-divider
    >
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <table class="vs-table vs-table--tbody-table">
        <template v-for="tr in table.file">
          <tr
            class="tr-values vs-table--tr tr-table-state-null selected"
            v-bind:key="tr.name"
          >
            <td class="td vs-table--td">{{ tr.name }}</td>
            <td class="td vs-table--td">
              <vx-tooltip text="Show" v-if="tr.path != ''">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  @click.stop="handleShowAttachment(tr)"
                  icon="icon-eye"
                />
              </vx-tooltip>
            </td>
            <td class="td vs-table--td">
              <template>
                <vx-tooltip text="Delete">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="handleDeleteAttachment(i, tr.id)"
                    icon="icon-trash"
                  />
                </vx-tooltip>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  props: {
    piId: {
      type: Number,
    },
    vendor: {
      type: String,
    },
    poCode: {
      type: String,
    },
    invCode: {
      type: String,
    },
    warehouseCode: {
      type: String,
    },
    warehouseName: {
      type: String,
    },
    createdDate: {
      type: String,
    },
  },
  created() {},
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        optionPaymentTerm: [],
        optionBankName: [],
        search: "",
        offset: 0,
        limit: 10,
        status_submit: false,
        notes: "",
        new_notes: "",
        comment: "",
        table: {
          inv_code: null,
          inv_date: null,
          due_date: null,
          payment_term: null,
          bank_name: null,
          account_name: null,
          account_number: null,
          total_inv_value: 0,
          item_value: 0,
          charges_value: 0,
          tax_value: 0,
          data: [],
          data_charges: [],
          data_payment_proposal: [],
          file: [],
        },
        bank: null,
        total_paid: 0,
        total_unpaid: 0,
        account_number: null,
        total_value: 0,
        description: "",
        vat_expired: false,
        is_skb: false,
      };
    },
    dateFormat(value) {
      if (!value) {
        return "";
      }
      return moment(String(value)).format("DD/MM/YYYY");
    },
    formatNumber() {
      if (
        Number(this.total_value.toString().replace(/,/g, "")) >
        Number(this.total_unpaid.toString().replace(/,/g, ""))
      ) {
        this.$vs.notify({
          color: "warning",
          title: "Information",
          text: "Check total unpaid.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        this.total_value = this.total_unpaid
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.total_value = Number(this.total_value.toString().replace(/,/g, ""))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    handleSubmit() {
      this.status_submit = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.doSubmit();
        }
      });
    },
    doSubmit() {
      let param = {
        pi_id: this.piId,
        inv_code: this.invCode,
        bank_id: this.bank.id ? this.bank.id : this.bank.ID,
        bank_name: this.bank.name ? this.bank.name : this.bank.Name,
        account_number: this.account_number,
        total_value: this.total_value,
        total_paid: this.total_paid,
      };
      this.$http
        .post("/api/v1/pi/propose-payment", param)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    handleShowAttachment(selected) {
      if (selected.path != "" && selected.path !== undefined) {
        this.downloadFileAwsS3(selected.path);
      } else if (selected.PathFile != "" && selected.PathFile !== undefined) {
        this.downloadFileAwsS3(selected.PathFile);
      }
    },
    handleDeleteAttachment(index, id) {
      this.fileAttachment = this.fileAttachment.filter((item, i) => i != index);
      this.deleteFile(id);
      console.log(this.fileAttachment);
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/pi/payment-proposal-line/" + this.piId)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.table.inv_date =
              this.invCode != 0
                ? moment(String(new Date(resp.data.inv_date))).format(
                    "DD/MM/YYYY"
                  )
                : null;
            this.table.due_date =
              this.invCode != 0
                ? moment(String(new Date(resp.data.due_date))).format(
                    "DD/MM/YYYY"
                  )
                : null;
            this.notes = resp.data.invoice_notes.toString().split(";");
            this.table.payment_term_name = resp.data.payment_term_name;
            this.table.data_payment = resp.data.detail_payment;
            this.table.bank_name =
              resp.data.bank_name +
              " - " +
              resp.data.account_number +
              " " +
              resp.data.account_name;
            this.tr_date =
              moment(String(resp.data.tr_date)).format("YYYY-MM-DD") ==
              "0001-01-01"
                ? ""
                : moment(String(new Date(resp.data.tr_date))).format(
                    "DD/MM/YYYY"
                  );
            this.tr_number = resp.data.tr_number;
            this.table.discount_value = resp.data.total_discount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.total_paid = resp.data.paid_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.total_whtax = resp.data.data_line.reduce(
              (accumulator, currentObj) => {
                if (resp.data.purchase_invoice.IsSkb === 1) {
                  return accumulator;
                } else {
                  return accumulator + currentObj.wh_tax;
                }
              },
              0
            );
            this.vat_expired =
              resp.data.purchase_invoice.VatExpired === 0 ? false : true;
            this.is_skb = resp.data.purchase_invoice.IsSkb === 1 ? true : false;
            // this.total_unpaid = (resp.data.unpaid_value - this.table.total_whtax)
            // 	.toFixed(2)
            // 	.toString()
            // 	.replace(/,/g, "")
            // 	.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.total_whtax = this.table.total_whtax
              .toFixed(2)
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.total_unpaid = resp.data.unpaid_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.total_inv_value = resp.data.total_invoice_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.item_value = resp.data.item_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.charges_value = resp.data.charge_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.tax_value = resp.data.tax_value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.po_code = resp.data.po_code;
            this.table.vendor = resp.data.vendor;
            this.comment = resp.data.purchase_invoice.CommentInvoice;
            this.description = resp.data.purchase_invoice.Description;
            let _this = this;
            resp.data.data_line.forEach(function (element, index) {
              _this.table.data.push({
                net: element.net
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                tax: element.tax
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                quantity: element.quantity
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                discount: element.discount
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                item_name: element.item_name,
                item_unit: element.item_unit,
                id: element.id,
                qty_received: element.qty_received,
                subtotal: (element.net - element.discount)
                  .toFixed(2)
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              });
            });

            resp.data.data_charge.forEach(function (element, index) {
              _this.table.data_charges.push({
                value: element.value
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                tax: element.tax
                  .toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                id: element.id,
                charge_name: element.charge_name,
                tax_rate: element.tax_rate,
              });
            });
            resp.data.data_attachment.map((r, i) => {
              _this.table.file.push({
                id: r.id,
                name: r.name,
                path: r.path,
                doc_type: r.doc_type,
              });
            });
            this.bank = {
              id: resp.data.bank_id_proposal,
              name: resp.data.bank_name_proposal,
            };
            this.account_number = resp.data.account_number_proposal;
            this.total_value = parseFloat(resp.data.paid_proposal)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.data_payment_proposal =
              resp.data.payment_proposal_proses;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
  },
  mounted() {
    if (this.piId) {
      this.getData();
      this.table.inv_code = this.invCode != 0 ? this.invCode : null;
    }
  },
  computed: {},
  watch: {
    piId() {
      Object.assign(this.$data, this.initialState());
      this.getData();
      this.table.inv_code = this.invCode != 0 ? this.invCode : null;
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}

.horizontal-divider {
  border-top: 1px solid #c1bbff;
  padding: 5px;
  margin-top: 15px;
}
</style>
